import React from "react";
import { useForm } from "react-hook-form";
import {
  Button,
  Flex,
  useToast,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
} from "@chakra-ui/react";

import {
  UPSERT_SKILL_MUTATION,
} from "../graphql/admin";

import MoblyzeApolloClient from "../services/MoblyzeApolloClient";

import {
  BasicInput,
  SectionTitle,
} from "./HookFormsInputs";

export default function AddSkillModal({
  createdCallback,
  isOpen,
  onClose,
  skill,
}) {
  const isCreate = !skill?.id || skill.id === "new";

  const toast = useToast();

  const {
    handleSubmit: handleSubmitModal,
    register: registerModal,
    control: controlModal,
    formState: { errors: errorsModal, isSubmitting: isSubmittingModal },
    reset,
  } = useForm({
    defaultValues: {
      name: skill?.name || "",
    },
  });

  async function onSubmit(values) {
    const variables = {
      ...values,
    };
    if (!isCreate) {
      // If editing an existing skill, we need to pass the id
      variables.id = skill.id;
    }

    try {
      const response = await MoblyzeApolloClient.mutate({
        mutation: UPSERT_SKILL_MUTATION,
        variables,
      });
      console.log("Response from upsert:", response);
      if (response?.data?.upsertSkill) {
        // If we successfully created or updated the skill, navigate back to the skills page
        if (createdCallback) {
          createdCallback(response.data.upsertSkill);
        }
        toast({
          title: "Skill added",
          description: "The skill has been successfully added.",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
        reset({
          name: "",
        });
        onClose();
      } else {
        console.error("Failed to upsert skill:", response);
        toast({
          title: "Error",
          description: "Failed to add skill",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error("Error during upsert:", error);
      toast({
        title: "Error",
        description: "An error occurred while adding the skill",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} variant={"darkMode"}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <ModalCloseButton />
        </ModalHeader>

        <ModalBody pb="4">
          <Flex direction="column">
            <form
              onSubmit={(event) => {
                event.stopPropagation();
                event.preventDefault();
                handleSubmitModal(onSubmit)(event);
              }}
            >
              <SectionTitle title="Add Skill" />

              <BasicInput
                label="Name"
                name="name"
                placeholder="Name of the skill"
                register={registerModal}
                control={controlModal}
                errors={errorsModal}
                required
              />

              <Button mt={4} isLoading={isSubmittingModal} type="submit">
                Save
              </Button>
            </form>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
